import { contacts, ContactTypes } from './contacts';
import { myData } from './myProfile';
import img1 from '../assets/images/small/img-1.jpg';
import img2 from '../assets/images/small/img-2.jpg';
import { MESSAGE_STATUS } from '../constants';

export interface AttachmentTypes {
    id: number;
    name: string;
    downloadLink: string;
    desc: string;
}

export interface ImageTypes {
    id: number;
    downloadLink: string;
}
export interface MessagesTypes {
    messageId: string;
    type?: string;
    text?: string;
    updatedAt: string;
    status: string;
    received: boolean;
    read: boolean;
    isForwarded?: boolean;
    meta: {
        receiver: string | number;
        sender: string | number;
        userData?: ContactTypes;
    };
    attachments?: AttachmentTypes[];
    image?: ImageTypes[];
    newimage?: ImageTypes[];
    replyOf?: MessagesTypes;
    updateUser: string;
}
export interface ConversationTypes {
    conversationId: string | number;
    userId: string;
    isGroupConversation?: boolean;
    typingUser?: string | number;
    messages: MessagesTypes[];
}

export const myId = myData.uid;
let conversations: ConversationTypes[] = [
    {
        conversationId: 1,
        userId: '614ecab4ac946a9bdafa4e3b',
        typingUser: '614ecab4ac946a9bdafa4e3b',
        messages: [
            {
                messageId: '1',
                text: 'Good morning 😊',
                updatedAt: new Date().toISOString(),
                status: MESSAGE_STATUS.SENT,
                received: true,
                read: true,
                meta: {
                    receiver: myId,
                    sender: '614ecab4ac946a9bdafa4e3b'
                },
                updateUser: 'default'
            },
            {
                messageId: '2',
                text: 'Good morning, How are you? What about our next meeting?',
                updatedAt: new Date().toISOString(),
                status: MESSAGE_STATUS.SENT,
                received: true,
                read: true,
                meta: {
                    receiver: '614ecab4ac946a9bdafa4e3b',
                    sender: myId
                },
                updateUser: 'default'
            },
            {
                messageId: '3',
                text: 'Yeah everything is fine. Our next meeting tomorrow at 10.00 AM',
                updatedAt: new Date().toISOString(),
                status: MESSAGE_STATUS.SENT,
                received: true,
                read: true,
                meta: {
                    receiver: myId,
                    sender: '614ecab4ac946a9bdafa4e3b'
                },
                updateUser: 'default'
            },
            {
                messageId: '4',
                text: "Hey, I'm going to meet a friend of mine at the department store. I have to buy some presents for my parents 🎁",
                updatedAt: new Date().toISOString(),
                status: MESSAGE_STATUS.SENT,
                received: true,
                read: true,
                meta: {
                    receiver: myId,
                    sender: '614ecab4ac946a9bdafa4e3b'
                },
                updateUser: 'default'
            },
            {
                messageId: '5',
                text: "Wow that's great",
                updatedAt: new Date().toISOString(),
                status: MESSAGE_STATUS.SENT,
                received: true,
                read: true,
                meta: {
                    receiver: '614ecab4ac946a9bdafa4e3b',
                    sender: myId
                },
                updateUser: 'default'
            },
            {
                messageId: '6',
                updatedAt: new Date().toISOString(),
                status: MESSAGE_STATUS.SENT,
                received: true,
                read: true,
                meta: {
                    receiver: myId,
                    sender: '614ecab4ac946a9bdafa4e3b'
                },
                image: [
                    {
                        id: 1,
                        downloadLink: img1
                    },
                    {
                        id: 2,
                        downloadLink: img2
                    }
                ],
                updateUser: 'default'
            },
            {
                messageId: '7',
                updatedAt: new Date().toISOString(),
                status: MESSAGE_STATUS.SENT,
                received: true,
                read: true,
                meta: {
                    receiver: '614ecab4ac946a9bdafa4e3b',
                    sender: myId
                },
                attachments: [
                    {
                        id: 1,
                        name: 'design-phase-1-approved.pdf',
                        downloadLink: '',
                        desc: '12.5 MB'
                    }
                ],
                updateUser: 'default'
            }
        ]
    },
    {
        conversationId: 2,
        userId: '61665bcb9a456823e282afa7',
        typingUser: contacts[0].id,
        isGroupConversation: true,
        messages: [
            {
                messageId: '1',
                text: 'Good morning Everyone',
                updatedAt: new Date().toISOString(),
                status: MESSAGE_STATUS.SENT,
                received: true,
                read: true,
                meta: {
                    receiver: myId,
                    sender: contacts[0].id,
                    userData: contacts[0]
                },
                updateUser: 'default'
            },
            {
                messageId: '2',
                text: 'Good morning, How are you? What about our next meeting?',
                updatedAt: new Date().toISOString(),
                status: MESSAGE_STATUS.SENT,
                received: true,
                read: true,
                meta: {
                    receiver: contacts[0].id,
                    sender: myId,
                    userData: contacts[0]
                },
                updateUser: 'default'
            },
            {
                messageId: '3',
                text: 'Yeah everything is fine, Our next meeting tomorrow at 10.00 am AM',
                updatedAt: new Date().toISOString(),
                status: MESSAGE_STATUS.SENT,
                received: true,
                read: true,
                meta: {
                    receiver: myId,
                    sender: contacts[1].id,
                    userData: contacts[1]
                },
                updateUser: 'default'
            },
            {
                messageId: '4',
                text: "Wow that's great",
                updatedAt: new Date().toISOString(),
                status: MESSAGE_STATUS.SENT,
                received: true,
                read: true,
                meta: {
                    receiver: myId,
                    sender: contacts[2].id,
                    userData: contacts[2]
                },
                updateUser: 'default'
            },
            {
                messageId: '5',
                text: '@Jean Berwick, Please Assign AB-123 to me',
                updatedAt: new Date().toISOString(),
                status: MESSAGE_STATUS.SENT,
                received: true,
                read: true,
                meta: {
                    receiver: contacts[0].id,
                    sender: myId,
                    userData: contacts[0]
                },
                updateUser: 'default'
            },
            {
                messageId: '6',
                text: 'Okay, Sure',
                updatedAt: new Date().toISOString(),
                status: MESSAGE_STATUS.SENT,
                received: true,
                read: true,
                meta: {
                    receiver: myId,
                    sender: contacts[3].id,
                    userData: contacts[3]
                },
                updateUser: 'default'
            }
        ]
    }
];

const onChangeConversations = (newData: ConversationTypes[]) => {
    conversations = newData;
};

export { conversations, onChangeConversations };
